var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bb-switch-container" },
    [
      _vm.frontLabel
        ? _c(
            "span",
            {
              staticClass: "bb-switch-label",
              staticStyle: { "margin-right": "10px" },
            },
            [_vm._v(_vm._s(_vm.frontLabel))]
          )
        : _vm._e(),
      _c("b-form-checkbox", {
        staticClass: "bb-switch",
        attrs: { switch: "", size: "lg", disabled: _vm.disabled },
        on: {
          input: function ($event) {
            return _vm.onSwitch($event)
          },
        },
        model: {
          value: _vm.passedValue,
          callback: function ($$v) {
            _vm.passedValue = $$v
          },
          expression: "passedValue",
        },
      }),
      _vm.label
        ? _c("span", { staticClass: "bb-switch-label" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }